import { useCallback, useEffect, useState } from "react";
import { getPaymentSumsOverview } from "../../../../../services/clearing/payment-sums";
import type { MonthlyPaymentSumRow } from "../../PaymentSums/hooks/useMonthlyPaymentSums";

type BufferedRow = Pick<
  MonthlyPaymentSumRow,
  "year" | "month" | "eroundSum" | "eroundStatus"
>;

export function useBufferedEroundSum() {
  const [rows, setRows] = useState<BufferedRow[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getPaymentSumsOverview()
      .then((data: BufferedRow[]) => {
        if (!cancelled) setRows(Array.isArray(data) ? data : []);
      })
      .catch((e: unknown) => {
        console.error("Failed to load buffered eRound sums", e);
        if (!cancelled) setRows([]);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const lookup = useCallback(
    (year: number, month: number): number | null => {
      const row = rows.find((r) => r.year === year && r.month === month);
      if (!row || row.eroundSum == null) return null;
      if (row.eroundStatus && row.eroundStatus !== "READY") return null;
      return row.eroundSum;
    },
    [rows]
  );

  return { lookup, ready };
}
